import { RunnerState } from '@rundown-studio/types'

import { faPause, faStop } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useAtomValue } from 'jotai'

import { isRunningAtom, runnerStateAtom } from '@/store/runner.store'

export function TransportStateIndicator() {
  const runnerState = useAtomValue(runnerStateAtom)
  const isRunning = useAtomValue(isRunningAtom)

  switch (runnerState) {
    case RunnerState.PRESHOW: {
      return <span className="h-3 w-3 rounded-full inline-block bg-gray-500" />
    }

    case RunnerState.ONAIR: {
      if (isRunning) {
        return (
          <span className="h-3 w-3 rounded-full inline-block text-red-500 bg-current glow animate-pulse" />
        )
      }

      return <FontAwesomeIcon icon={faPause} className="text-gray-400" />
    }

    case RunnerState.ENDED: {
      return <FontAwesomeIcon icon={faStop} className="text-gray-400" />
    }

    default: {
      const _exhaustive: never = runnerState
      return _exhaustive
    }
  }
}
